import { Box, Flex } from '@chakra-ui/react'

const TagsColorMap: Record<string, string> = {
  Unlimited: 'linear-gradient(100deg, #FF2D78 7.17%, #FF6422 95.77%);',
  Airdrop: 'linear-gradient(96deg, #974BFF -1.27%, #B37BFF 95.78%);',
  Special: 'linear-gradient(98deg, #8C46FF -6.77%, #F0247A 103.01%);',
  Promo: 'linear-gradient(98deg, #8C46FF -6.77%, #F0247A 103.01%);',
  'Limited Edition': 'linear-gradient(96deg, #974BFF -1.27%, #B37BFF 95.78%);',
  'Low Risk': 'linear-gradient(101deg, #99C53E 4.34%, #99C53E 95.66%);',
  'Medium Risk': 'linear-gradient(101deg, #5FC6FF 4.34%, #86D3FF 95.66%);',
  'High Risk': 'linear-gradient(100deg, #FF782D 7.17%, #FD9A62 95.77%);',
}

export const LootboxTags = ({ tags }: { tags: Array<string> }) => {
  return (
    <Flex gap={2}>
      {tags.map((text, index) => (
        <Box
          fontSize={'xs'}
          key={index}
          rounded={'lg'}
          bg={TagsColorMap[text] || 'green'}
          fontWeight={700}
          py={1.5}
          px={2}
        >
          {text}
        </Box>
      ))}
    </Flex>
  )
}
